import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import '../stylesheets/ModalOp.css';
class SettingUpdateDialogue extends React.Component {

    componentDidMount() {
        this.timer = setTimeout(() => this.props.closeDialogue(), 3000);
    }
    componentWillUnmount() {
        clearTimeout(this.timer);
    }
    handleClose = () => this.props.closeDialogue();
    render() {
        return (
            <Modal show={this.props.show} backdrop="static" onHide={this.handleClose} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Preference Updated</Modal.Title>
                </Modal.Header>
                <Modal.Body className="my-modal-body">{this.props.currency ? 'Language : ' + this.props.language + '\nCurrency : ' + this.props.currency : 'Language : ' + this.props.language}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" id="closeDialogue" onClick={this.handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
export default SettingUpdateDialogue;